// ObserveHandle: the return value of a live query.
export default class ObserveHandle {}
